import { render, staticRenderFns } from "./PeopleCycle.vue?vue&type=template&id=0961e6f4&scoped=true"
import script from "./PeopleCycle.vue?vue&type=script&lang=js"
export * from "./PeopleCycle.vue?vue&type=script&lang=js"
import style0 from "./PeopleCycle.vue?vue&type=style&index=0&id=0961e6f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0961e6f4",
  null
  
)

export default component.exports